import { render, staticRenderFns } from "./newsAny.vue?vue&type=template&id=20849332&scoped=true&"
import script from "./newsAny.vue?vue&type=script&lang=js&"
export * from "./newsAny.vue?vue&type=script&lang=js&"
import style0 from "./newsAny.vue?vue&type=style&index=0&id=20849332&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20849332",
  null
  
)

export default component.exports